export default "__VITE_ASSET__CHd4_uPe__"